<template>
    <div class="learn page-color" :class="'level' + currentLevel">
        <header-back></header-back>

        <div class="container">
            <!--
            <h3 class="level-header"> LEVEL {{currentLevel}}
                <p> {{counter + 1}} / {{total}} </p>
            </h3>
            -->

            <div class="container-selection" v-if="selectedTense != null">

                <selection-card :selected="selectedTense"
                                :verb="verb"
                                :disabled="true"
                                :speech="true"
                ></selection-card>

                <div class="definition">
                    <transition name="fade-left" mode="out-in">
                        <button v-if="showDefinition" @click="showDefinition = false"><img src="../assets/images/iconSpan.png" alt="spanish"></button>

                    </transition>

                    <transition name="fade-left" mode="in-out">
                        <button v-if="!showDefinition" @click="showDefinition = true"><img src="../assets/images/iconPen.png" alt="definition"></button>
                    </transition>

                    <div v-if="showDefinition">
                        <p v-html="verb.definition"></p>
                        <img v-if="verb.image" :src="currentImage" alt="image">
                    </div>
                    <div v-if="!showDefinition" class="translation">
                        {{verb.spanish}}
                    </div>

                </div>
            </div>

            <div class="actions">
                <button :class="{disabled: counter === 0}" @click="goToPrev()">⇦</button>
                <button :class="{disabled: counter === total - 1}" @click="goToNext()">⇨</button>
            </div>
        </div>
    </div>
</template>

<script>

    import headerBack from '../components/Header';
    import irregularVerbsData from '../data/irregularVerbs';
    import selectionCard from '../components/SelectionCard';

    export default {
        data() {
            return {
                currentLevel: this.$route.params.id,
                irregularVerbs: irregularVerbsData.IrregularVerbs,
                copyVerbs: [],
                total: 0,
                counter: 0,
                selectedTense: null,
                showDefinition: true
            }
        },
        created() {
            let vm = this;
            //this.copyVerbs = this.irregularVerbs.slice(0);
            this.copyVerbs = this.irregularVerbs.filter(function(value) {
                return value.level === vm.currentLevel;
            });
            this.total = this.copyVerbs.length;
            this.loadVerb();
        },
        methods: {
            loadVerb(){
                this.showDefinition = true;
                this.selectedTense = this.copyVerbs[this.counter].infinitive;
                this.verb = this.copyVerbs[this.counter];
                this.verb.image = this.copyVerbs[this.counter].image;
            },
            goToPrev(){
                if (this.counter >= 0) {
                    this.counter--;
                    this.loadVerb();
                }
            },
            goToNext(){
                if (this.counter < this.total - 1){
                    this.counter++;
                    this.loadVerb();
                }
            }
        },
        computed: {
          currentImage(){
              if (this.verb.image){
                  return require('../assets/images/verbs/' + this.verb.image);
              }
              return null
          }
        },
        components: {
            headerBack,
            selectionCard
        }
    }
</script>